import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ISession, IUser, ISetting } from '../Models';

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  readonly key = { currentSession: 'current-session', currentUser: 'current-user' };

  private dataSource = new BehaviorSubject<any>({});
  data = this.dataSource.asObservable();

  constructor() { }

  public set(key: string, _value: any, propagate?: boolean) {

      let value = JSON.stringify(_value);
      localStorage.setItem(key, value);

      if (propagate != false) {
        this.dataSource.next({ key, value });
      }
  }

  public get(key: string): string {
      return localStorage.getItem(key);
  }

  public initSession(user: IUser) {
      this.updateSession(user.sessions[0]);
      delete user.sessions;
      this.set(this.key.currentUser, user);
  }

  public updateSession(session: ISession) {
      session.token['expires_at'] = session.token.expires_in * 1000 + new Date().getTime();
      this.set(this.key.currentSession, session, false);
  }

  public endSession() {
      this.delete(this.key.currentSession);
      this.delete(this.key.currentUser);
  }

  public setCurrentUser(user: IUser) {
      this.set(this.key.currentUser, user);
  }

  public getCurrentUser(): IUser {
      return JSON.parse(this.get(this.key.currentUser)) as IUser || {};
  }

  public removeCurrentUser() {
      this.delete(this.key.currentUser);
  }

  public delete(key: string) {
      localStorage.removeItem(key);
  }


  public reset(exclusions?: string[]) {

        if (exclusions && exclusions[0]) {
        const excluded = exclusions.map(exclusion => ({ key: exclusion, value: localStorage.getItem(exclusion) }));
        localStorage.clear();
        excluded.forEach(x => localStorage.setItem(x.key, x.value));
        } else {
        localStorage.clear();

        }
    }


  public updateUserSettings(setting: ISetting) {
      let user: IUser = this.getCurrentUser();
      user = Object.assign({}, user, setting);
      this.setCurrentUser(user);
  }

  public getCurrentSession(): ISession {
      return JSON.parse(this.get(this.key.currentSession)) as ISession || {};
  }

  public hasStorage(type: string) {

      try {
          var storage = window[type],
              x = '__storage_test__';
          storage.setItem(x, x);
          storage.removeItem(x);
          return true;
      }
      catch (e) {
          return e instanceof DOMException && (
              // everything except Firefox
              e.code === 22 ||
              // Firefox
              e.code === 1014 ||
              // test name field too, because code might not be present
              // everything except Firefox
              e.name === 'QuotaExceededError' ||
              // Firefox
              e.name === 'NS_ERROR_DOM_QUOTA_REACHED') &&
              // acknowledge QuotaExceededError only if there's something already stored
              storage.length !== 0;
      }
  }
}
